import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';
import {
    getDashboard as getDashboardApi,
    getDashboardById as getDashboardByIdApi,
    createDashboard as createDashboardApi,
    updateDashboard as updateDashboardApi,
    deleteDashboard as deleteDashboardApi,
} from 'helpers/api/dashboard';
import { dashboardApiResponseSuccess, dashboardApiResponseError } from './actions';
import { DashboardActionTypes } from './constants';

/**
 * Fetch latest / list of dashboards
 */
function* getDashboards(): SagaIterator {
    try {
        const response = yield call(getDashboardApi);
        yield put(dashboardApiResponseSuccess(DashboardActionTypes.GET_DASHBOARDS, response.data));
    } catch (error: any) {
        yield put(dashboardApiResponseError(DashboardActionTypes.GET_DASHBOARDS, error));
    }
}

/**
 * Fetch single dashboard by ID (full detail with banners + sections)
 */
function* getDashboardById({ payload }: any): SagaIterator {
    try {
        const response = yield call(getDashboardByIdApi, payload.id);
        yield put(dashboardApiResponseSuccess(DashboardActionTypes.GET_DASHBOARD_BY_ID, response.data));
    } catch (error: any) {
        yield put(dashboardApiResponseError(DashboardActionTypes.GET_DASHBOARD_BY_ID, error));
    }
}

/**
 * Create dashboard
 */
function* createDashboard({ payload }: any): SagaIterator {
    try {
        const response = yield call(createDashboardApi, payload);
        yield put(dashboardApiResponseSuccess(DashboardActionTypes.CREATE_DASHBOARD, response.data));
    } catch (error: any) {
        yield put(dashboardApiResponseError(DashboardActionTypes.CREATE_DASHBOARD, error));
    }
}

/**
 * Update dashboard (full-replace banners/sections if provided)
 */
function* updateDashboard({ payload }: any): SagaIterator {
    try {
        const { id, data } = payload;
        const response = yield call(updateDashboardApi, id, data);
        yield put(dashboardApiResponseSuccess(DashboardActionTypes.UPDATE_DASHBOARD, response.data));
    } catch (error: any) {
        yield put(dashboardApiResponseError(DashboardActionTypes.UPDATE_DASHBOARD, error));
    }
}

/**
 * Delete dashboard
 */
function* deleteDashboard({ payload }: any): SagaIterator {
    try {
        yield call(deleteDashboardApi, payload.id);
        yield put(dashboardApiResponseSuccess(DashboardActionTypes.DELETE_DASHBOARD, payload.id));
    } catch (error: any) {
        yield put(dashboardApiResponseError(DashboardActionTypes.DELETE_DASHBOARD, error));
    }
}

// ─── Watchers ───────────────────────────────────────────────────────────────

export function* watchGetDashboards() {
    yield takeEvery(DashboardActionTypes.GET_DASHBOARDS, getDashboards);
}

export function* watchGetDashboardById() {
    yield takeEvery(DashboardActionTypes.GET_DASHBOARD_BY_ID, getDashboardById);
}

export function* watchCreateDashboard() {
    yield takeEvery(DashboardActionTypes.CREATE_DASHBOARD, createDashboard);
}

export function* watchUpdateDashboard() {
    yield takeEvery(DashboardActionTypes.UPDATE_DASHBOARD, updateDashboard);
}

export function* watchDeleteDashboard() {
    yield takeEvery(DashboardActionTypes.DELETE_DASHBOARD, deleteDashboard);
}

// ─── Root saga ───────────────────────────────────────────────────────────────

function* dashboardSaga() {
    yield all([
        fork(watchGetDashboards),
        fork(watchGetDashboardById),
        fork(watchCreateDashboard),
        fork(watchUpdateDashboard),
        fork(watchDeleteDashboard),
    ]);
}

export default dashboardSaga;
